import type { ToolOutput } from '../../services/api'
import { Metric } from '../../ds'

interface MetricCardProps {
  output: ToolOutput
}

/**
 * One number an answer carries, drawn as the design system's `Metric` (D-37).
 *
 * The tool output says the direction (`trend`) and the size (`change`, a %)
 * separately, so the delta handed to `Metric` is signed by the trend, never by
 * the sign of `change`: up is good, down is bad, no trend is "no change".
 */
const MetricCard = ({ output }: MetricCardProps) => {
  const { title, value, change, trend } = output

  // A title is optional: inside a source card the card's own header names the
  // number, and repeating it here would print the same label twice.
  if (!value) {
    return null
  }

  const size = change !== undefined ? Math.abs(change) : undefined
  const delta = size === undefined ? undefined : trend === 'up' ? size : trend === 'down' ? -size : 0

  return (
    <Metric
      label={title ?? ''}
      value={value}
      delta={delta}
      deltaText={size !== undefined ? `${size.toFixed(1)}%` : undefined}
    />
  )
}

export default MetricCard
